import * as React from 'react';
import { cn } from '../lib/utils';

type CardProps = React.ComponentPropsWithoutRef<'div'>;

/**
 * A bordered white container. Clear prefers dividers and whitespace; use a
 * card for a self-contained object, not to frame every block.
 */
export function Card({ className, ...props }: CardProps) {
  return (
    <div
      className={cn('rounded-lg border border-border bg-surface text-foreground', className)}
      {...props}
    />
  );
}

export function CardHeader({ className, ...props }: CardProps) {
  return <div className={cn('flex flex-col gap-1 p-5', className)} {...props} />;
}

export function CardTitle({
  className,
  ...props
}: React.ComponentPropsWithoutRef<'h3'>) {
  return <h3 className={cn('text-section-title text-foreground', className)} {...props} />;
}

export function CardDescription({
  className,
  ...props
}: React.ComponentPropsWithoutRef<'p'>) {
  return <p className={cn('text-sm text-muted-foreground', className)} {...props} />;
}

export function CardContent({ className, ...props }: CardProps) {
  return <div className={cn('p-5 pt-0', className)} {...props} />;
}

export function CardFooter({ className, ...props }: CardProps) {
  return <div className={cn('flex items-center p-5 pt-0', className)} {...props} />;
}
